var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.08984 16.3623C5.09001 15.981 5.399 15.672 5.78027 15.6719L15.3975 15.6719C15.6617 15.6716 15.876 15.4566 15.876 15.1924L15.876 5.7793C15.8763 5.39821 16.1853 5.08902 16.5664 5.08887C16.9477 5.08887 17.2565 5.39811 17.2568 5.7793L17.2568 15.1924C17.2568 16.2196 16.4246 17.0525 15.3975 17.0527L5.78027 17.0527C5.3989 17.0526 5.08984 16.7437 5.08984 16.3623ZM-6.64037e-07 1.86133C3.69203e-05 0.834015 0.833031 0.000976526 1.86035 0.000976481L12.5459 0.000976014C13.5731 0.00112474 14.4062 0.83411 14.4062 1.86133L14.4062 12.5469C14.4062 13.5741 13.5731 14.4071 12.5459 14.4072L1.86035 14.4072C0.833057 14.4072 8.32368e-05 13.5741 -1.96957e-07 12.5469L-6.64037e-07 1.86133ZM1.38086 12.5469C1.38094 12.8112 1.596 13.0264 1.86035 13.0264L12.5459 13.0264C12.8101 13.0262 13.0243 12.8111 13.0244 12.5469L13.0244 1.86133C13.0244 1.59705 12.8102 1.38296 12.5459 1.38281L1.86035 1.38281C1.59597 1.38281 1.3809 1.59696 1.38086 1.86133L1.38086 12.5469Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.677af341fefc3448be221ce9d1cda129.svg";
export { ForwardRef as ReactComponent };